import type { FaireProductEntity } from "../../entity_types/product";

export const p_5c47k7gdd2: FaireProductEntity = {
  token: "p_5c47k7gdd2",
  type: "product",
  name: "Corkscrew, Olives",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/e896d8c64fee6692e7c01947b6881252d274520a3d7b3beed06f07ceb1d84c65.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c99e583af6b196ac2210fa6ca8106eaf086228d8850fc0b97b8861e6fdaf1c32.jpeg",
    "https://cdn.faire.com/fastly/880fa80605a8d9c4f21467e65be413eb1ceaf92a0413176d3e56dc2b561c2c3d.jpeg",
    "https://cdn.faire.com/fastly/29733a54e87985f78b2692e5d8c52537308089380d9178a7a3b5c6639cf319df.jpeg",
    "https://cdn.faire.com/fastly/955861d94151c0419bdc48674ff1711e826e8988baff66ea54932f28677e6c23.jpeg",
    "https://cdn.faire.com/fastly/a84bdecd0abfab3594ed750895e8503fc84afaee6ba49541a8c3a5d007d0b760.jpeg",
    "https://cdn.faire.com/fastly/3c81da0a8fd615ab893be011051af504fd41768ae6e67e977c0704def16c5886.jpeg",
    "https://cdn.faire.com/fastly/ac1d3c372234b8396205362e8c1698d84c63d330cc7915587e2bfcbd316de1a9.jpeg"
  ],
  priceDollars: 11,
  description: "You’ll want to keep this one out of the drawer and on display 24/7. This corkscrew features a fun stacked olive design that doubles as functional art for your bar cart. Bonus: it also comes with a built-in bottle opener, making it your new favorite party trick.\n\nFeatures:\n\nCorkscrew and bottle opener combo\n\nFeatures a playful stacked olive design\n\nPerfect for parties, picnics, or bar cart display\n\nMade for easy opening of wine and bottled beverages\n\nDesigned in Bando’s signature bright and whimsical style\n\n\nIdeal For:\n\nGift shops and home goods boutiques\n\nKitchenware and lifestyle retailers\n\nHosts, entertainers, and cocktail lovers\n\nWholesale buyers seeking fun, functional bar accessories",
  tags: [],
  msrpDollars: 22.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:14.678Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
